require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-emily-aviva-kapor-mater.json") })
        }
      }, "path---blog-author-emily-aviva-kapor-mater");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-emily-aviva-kapor-mater!./.cache/json/blog-author-emily-aviva-kapor-mater.json
// module id = 632
// module chunks = 231608221292675